import React from 'react'
import { Button } from 'spa/member/components/Button'
import styled from 'styled-components'
import { OnChangeStep } from '../types'
import { WorkPreferenceFormNames } from '../../constants'

export type Props = {
  onChangeStep: OnChangeStep
  currentStep: number
  sending?: boolean
}

const StyledSubFooterContainer = styled.div`
  width: 100%;
`

const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

const StyledButton = styled(Button)`
  width: 166px;

  @media ${props => props.theme.media.sm} {
    width: 180px;
  }
`

const StyledBackButton = styled(StyledButton)`
  background-color: ${props => props.theme.members.colors.silver._10};
  color: ${props => props.theme.members.colors.emeraldGreen._60};

  &:disabled {
    background-color: ${props => props.theme.members.colors.silver._30};
    color: ${props => props.theme.members.colors.silver._100};
  }
`

const StyledNextButton = styled(StyledButton)`
  background-color: ${props => props.theme.members.colors.appleGreen._60};
  color: ${props => props.theme.members.colors.white};
`

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.members.colors.silver._50};
  margin: 2.5rem 0 1.5rem;
`

const StyledCloseLinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const StyledCloseLink = styled.a`
  font-size: .75rem;
  font-weight: 700;
  color: ${props => props.theme.members.colors.silver._100};
  cursor: pointer;
  text-decoration: underline;
  letter-spacing: 0.2px;

  @media ${props => props.theme.media.sm} {
    font-size: .875rem;
  }
`

const isFirstStep = (currentStep: number) => currentStep === 1
const isLastStep = (currentStep: number) => currentStep === 4

const nextButtonText = (currentStep: number) => isLastStep(currentStep) ? '保存して閉じる' : '保存して次へ'

const formName = (currentStep: number) => {
  switch (currentStep) {
    case 1:
      return WorkPreferenceFormNames.CurrentSituation
    case 2:
      return WorkPreferenceFormNames.DesiredProject
    case 3:
      return WorkPreferenceFormNames.Skills
    case 4:
      return WorkPreferenceFormNames.Others
    default:
      return ''
  }
}

export const StyledSubFooter: React.FC<Props> = (props: Props) => {
  const onClickBack = () => props.onChangeStep('back')

  return(
    <StyledSubFooterContainer>
      <StyledButtonsContainer>
        <StyledBackButton disabled={isFirstStep(props.currentStep)} onClick={onClickBack} data-cy="step-back-button">
            前へ
        </StyledBackButton>
        <StyledNextButton type="submit" form={formName(props.currentStep)} disabled={props.sending} data-cy="step-next-button">
          {nextButtonText(props.currentStep)}
        </StyledNextButton>
      </StyledButtonsContainer>
      <StyledDivider />
      <StyledCloseLinkContainer>
        <StyledCloseLink href="/dashboard" data-cy="close-link">
          保存せずに閉じる
        </StyledCloseLink>
      </StyledCloseLinkContainer>
    </StyledSubFooterContainer>
  )
}
